import React from 'react';
import styled from 'styled-components';
import { adminTheme } from '../styles/adminTheme';

const Card = styled.div`
  background: ${adminTheme.colors.cardBg};
  border: 1px solid ${adminTheme.colors.border};
  border-radius: ${adminTheme.borderRadius};
  padding: 16px 20px;
  min-width: 160px;
  flex: 1;
`;

const Value = styled.div`
  font-size: 28px;
  font-weight: 700;
  color: ${adminTheme.colors.text};
  line-height: 1.2;
`;

const Label = styled.div`
  font-size: 12px;
  color: ${adminTheme.colors.textSecondary};
  margin-top: 4px;
`;

interface StatCardProps {
  value: number | string;
  label: string;
}

export const StatCard: React.FC<StatCardProps> = ({ value, label }) => {
  return (
    <Card>
      <Value>{value}</Value>
      <Label>{label}</Label>
    </Card>
  );
};
